// extracted by mini-css-extract-plugin
export default {"safari":"yrabQPVMmHSuirzFolP2"};